<title>{{ fileAssetsPage.htmlTitle }}</title>
<app-file-assets-note-section *ngIf="isNoteSectionExist" [noteSections]="fileAssetsPage.needMoreSamplesSections!"></app-file-assets-note-section>
<app-file-assets-section *ngIf="isindexXMLSamplesSectionExist" [sections]="fileAssetsPage.indexXMLSamplesSection"></app-file-assets-section>
<app-file-assets-table-section [tableSections]="fileAssetsPage.tableSections"></app-file-assets-table-section>
